import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-sm font-bold" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "text-sm font-bold" }
const _hoisted_5 = { class: "" }

import { ref, onMounted, reactive, defineComponent, getCurrentInstance } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import apiUseCase from '@/usecase/apiUseCase'
import InputSwitch from 'primevue/inputswitch'
import numberFormat from '@/utils/helpers/numberFormat'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import SpbuForm from './Form.vue'
import ListActions from './components/ListActions.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const endpoint = '/management/v2/FuelStationPartners'
const selectedRow = ref(null) as any
const router = useRouter()

const tabelParams = reactive({
  endpoint: '/management/v2/FuelStationPartners',
  headerTitle: 'Master Partner SPBU',
  buttonTitle: 'Tambah Partner',
  editTitle: 'Detail Partner',
  pageFormRoute: 'master-spbu-form',
  isOpenNewPageForm: true,
  confirmDialogDelete: {
    title: 'Hapus Partner SPBU?',
    subTitle: 'Pastikan Partner SPBU yang Anda hapus sudah sesuai.',
    btnSubmitTitle: 'Hapus Partner SPBU',
  },
  columnsTable: [
    {
      field: 'Name',
      headerName: 'Nama Partner',
      searchable: true,
      fieldSearch: 'q',
      isRender: false
    },
    {
      field: 'Address',
      headerName: 'Alamat',
      searchable: true,
      fieldSearch: 'q',
      isRender: false
    },
    {
      field: 'MsBankName',
      headerName: 'Rekening',
      searchable: true,
      fieldSearch: 'q',
      isRender: true
    },
    {
      field: 'MaxStock',
      headerName: 'Stok BBM',
      searchable: false,
      fieldSearch: '',
      isRender: true,
      sortable: true
    },
    {
      field: 'IsActive',
      headerName: 'Aktif',
      searchable: false,
      fieldSearch: '',
      isRender: true,
    },
  ]
})

const changeIsActive = async (val: any) => {
  const data = {
    // Id: val.Id,
    IsActive: val.IsActive
  }
  const response = await apiUseCase.patchWithNoId(`${endpoint}/${val.Id}/Activate`, data)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      detail: 'Data berhasil diubah',
      group: 'bc',
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: response.message,
      group: 'bc',
      life: 3000
    })
    val.IsActive = !val.IsActive
  }
}

const handleRowSelected = (row: any) => {
  selectedRow.value = row
  console.log('Row yang dipilih:', selectedRow.value)
}

const viewDetailAct = () => {
  router.push({
    name: 'master-spbu-form',
    params: { id: encryptDecriptMethods.encrypt(selectedRow.value) }
  })
}

const onEditFuelPrice = () => {
  console.log('hehe')
  router.push({
    name: 'master-spbu-fuel-form',
    params: { id: encryptDecriptMethods.encrypt(selectedRow.value) }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DataTable, {
      columns: tabelParams.columnsTable,
      endpoint: tabelParams.endpoint,
      headerTitle: tabelParams.headerTitle,
      buttonTitle: tabelParams.buttonTitle,
      isOpenNewPageForm: tabelParams.isOpenNewPageForm,
      pageFormRoute: tabelParams.pageFormRoute,
      editTitle: tabelParams.editTitle,
      showColumnActivate: false,
      isDelete: false,
      orderBy: 'IsActive desc',
      isEditFuelPrice: false,
      hasCustomAction: true,
      onRowSelected: handleRowSelected,
      confirmDialogDelete: tabelParams.confirmDialogDelete
    }, {
      MsBankName: _withCtx(({ slotProps }) => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(slotProps.data.MsBankName ?? '-') + " - " + _toDisplayString(slotProps.data.AccountNumber ?? '-'), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(slotProps.data.AccountName ?? '-'), 1)
      ]),
      MaxStock: _withCtx(({ slotProps }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.Stocks, (data) => {
          return (_openBlock(), _createElementBlock("div", { key: data }, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(`${data.Name}:`) + " ", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(`${_unref(numberFormat)(data.CurrentStock ?? 0)} L`), 1)
            ])
          ]))
        }), 128))
      ]),
      IsActive: _withCtx(({ slotProps }) => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(InputSwitch), {
            modelValue: slotProps.data.IsActive,
            "onUpdate:modelValue": ($event: any) => ((slotProps.data.IsActive) = $event),
            onChange: ($event: any) => (changeIsActive(slotProps.data))
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
        ])
      ]),
      customAction: _withCtx(() => [
        _createVNode(ListActions, {
          viewDetail: true,
          editFuelPrice: true,
          viewDetailTitle: tabelParams.editTitle,
          onViewDetail: viewDetailAct,
          onEditFuelPrice: onEditFuelPrice
        }, null, 8, ["viewDetailTitle"])
      ]),
      _: 1
    }, 8, ["columns", "endpoint", "headerTitle", "buttonTitle", "isOpenNewPageForm", "pageFormRoute", "editTitle", "confirmDialogDelete"])
  ]))
}
}

})